<template>
    <DatatablePageLayout>
        <template v-slot:actionButtons>
            <button class="sk-btn sk-btn-primary rounded-lg" @click="handleCreate">
                {{ $t('apps.campaigns.form.createButton') }}
            </button>
        </template>
        <template v-slot:datatable>
            <DataTable 
                :config="datatableConfig" 
                :elements="templates" 
                :stripe="true" 
                :draggable="false"
                :sst="true" 
                :pagination="pagination" 
                @action="handleAction" 
                @filter="handleFilter" 
            />
        </template>
    </DatatablePageLayout>
</template>

<script>

import { v4 as uuidv4 } from 'uuid';
import loader from "@/modules/Shared/Mixins/loader";
import DataTable from "@/modules/Shared/Components/table/SKDataTable.vue";
import PaginationService from "@/modules/Shared/Services/PaginationService";
import DatatablePageLayout from "@/modules/Shared/Pages/DatatablePageLayout.vue";
import AppConditionTemplateService from "@/modules/Admin/Services/AppConditionsService";

export default {
    name: "AppConditionTemplatesPage",
    components: { DataTable, DatatablePageLayout },
    mixins: [loader],
    data() {
        return {
            templates: [],
            datatableConfig: [
                { 'field' : 'id_ref', head : this.$t('admin.app-conditions-templates.id_ref'), 'searchable' : true, 'sortable' : false},
                { 'field' : 'reference', head : this.$t('admin.app-conditions-templates.reference'), 'searchable' : false, 'sortable' : false},
                { 'field' : 'actions', 'type': 'actions', head : this.$t("geofences.geofences-messages.actions"), 'searchable' : false, 'sortable' : false }
            ],
            pagination: {},
        }
    },
    async created() {
        this.loadAndNotifyError(async () => {
            await this.getTemplates({
                filters: [],
                page: 1
            })
        })
    },
    methods: {
        async getTemplates(params) {
            const templateResponse = await AppConditionTemplateService.getAppConditionTemplates(PaginationService.parseParameters(params))
            this.templates = this.parseTemplates(templateResponse.data)
              this.pagination = {
                  per_page: templateResponse.per_page,
                  total: templateResponse.total
              }
        },

        parseTemplates(templates) {
            return templates.map(template => ({
                ...template,
                actions: [ 'edit', 'delete' ]
            }))
        },

        async handleFilter(params) {
            await this.getTemplates(params)
        },
        async handleAction(type, uuid){
            switch(type) {
                case 'edit':
                    await this.$router.push({
                        name: 'admin-app-condition-templates-create',
                        params: { uuid: uuid }
                    })
                    break
                case 'delete':
                    await this.deleteTemplate(uuid)
                    break
            }
        },
        async handleCreate() {
            await this.$router.push({
                name: 'admin-app-condition-templates-create',
                params: { uuid: uuidv4() }
            })
        },

        async deleteTemplate(uuid) {
            await this.loadAndNotify(async () => {
                await AppConditionTemplateService.deleteAppConditionTemplate(uuid)
                await this.getTemplates({ filters: [], page: 1 })
            })
        }
    }
};
</script>